'use client'

import { LoginForm } from '@/components/molecules/auth/LoginForm'
import { HomeHeader } from '@/components/molecules/header-simple/HomeHeader'
import { VisionRadar } from '@/components/molecules/vision-radar/VisionRadar'
import { useAuthStore } from '@/features/auth'
import { useRegistrationStore } from '@/features/auth/stores/registration-store'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

export function LoginScreen() {
	const { isAuthenticated, isLoading, isHydrated, onboardingCompleted, user } = useAuthStore()
	const { setStep, updateData: updateRegistrationData } = useRegistrationStore()
	const router = useRouter()

	useEffect(() => {
		if (!isHydrated || isLoading) {
			return
		}
		if (isAuthenticated && onboardingCompleted) {
			router.push('/dashboard')
		} else if (isAuthenticated && !onboardingCompleted) {
			// Ya tiene cuenta y email confirmado → wizard en step 1
			setStep(1)
			updateRegistrationData({
				email: user?.email ?? '',
				emailConfirmed: true,
				supabaseId: user?.id,
			})
			router.push('/register')
		}
	}, [
		isAuthenticated,
		isLoading,
		isHydrated,
		onboardingCompleted,
		user,
		router,
		setStep,
		updateRegistrationData,
	])

	if (!isHydrated || isLoading) {
		return (
			<div className="flex min-h-dvh items-center justify-center bg-white">
				<div className="h-10 w-10 animate-spin rounded-full border-b-2 border-[--brand-primary]" />
			</div>
		)
	}

	if (isAuthenticated) {
		return null
	}

	return (
		<div className="relative mx-auto flex min-h-dvh w-full max-w-[430px] flex-col overflow-hidden bg-white text-black">
			{/* Back button — regresa al home landing */}
			<button
				onClick={() => router.push('/')}
				aria-label="Volver al inicio"
				className="absolute top-16 left-4 z-20 flex items-center gap-1.5 text-[11px] font-semibold tracking-[0.18em] text-(--brand-secondary) uppercase transition-opacity hover:opacity-70"
			>
				<svg width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden="true" className="shrink-0">
					<path d="M13 5H3" stroke="var(--brand-primary)" strokeWidth="1.8" strokeLinecap="square" />
					<path d="M6 1L2 5L6 9" stroke="var(--brand-primary)" strokeWidth="1.8" strokeLinecap="square" strokeLinejoin="miter" />
				</svg>
				Volver
			</button>

			{/* Header (Sink-o logo) */}
			<div className="relative z-10 w-full shrink-0">
				<HomeHeader />
			</div>

			<main className="flex flex-1 flex-col pt-6 pb-8">
				{/* Animated VisionRadar component */}
				<VisionRadar value={86} label="VISIÓN" className="mt-4 mb-2" />

				{/* Welcome Tag */}
				<div className="mt-8 flex w-full flex-col px-6">
					<div className="relative mb-4 inline-flex w-fit bg-[#1565F2] px-3 py-1 text-xs font-bold tracking-widest text-white">
						WELCOME BACK
						{/* Tooltip triangle */}
						<div className="absolute top-full left-4 h-0 w-0 border-x-[6px] border-t-[8px] border-x-transparent border-t-[#1565F2]" />
					</div>

					{/* Form Container */}
					<div className="w-full">
						<LoginForm />
					</div>
				</div>
			</main>
		</div>
	)
}
